<script setup lang="ts">
import {
  approveExistingCustomerAccessRequest,
  useExisitngCustomerAccessRequest,
} from '@/api/profiles'
import { useMutation } from '@pinia/colada'

definePage({
  meta: {
    layout: 'public',
    requiresAuth: false,
  },
})
const route = useRoute()
const isValid = computed(() => !!route.query.id && !!route.query.nonce)
const id = computed(() => route.query.id as string)
const nonce = computed(() => route.query.nonce as string)
const { data, status } = useExisitngCustomerAccessRequest(id.value, nonce.value, isValid.value)
const { mutateAsync, status: acceptStatus } = useMutation({
  mutation: approveExistingCustomerAccessRequest,
})
</script>

<template>
  <Frame>
    <div v-if="acceptStatus === 'success'">
      <h2 class="justify-self-center text-2xl">The request has been accepted</h2>
    </div>
    <template v-else>
      <div
        v-if="status === 'pending'"
        class="center flex flex-col justify-items-center justify-self-center"
      >
        <h2 class="text-2xl">Finding Access Request</h2>
        <LoadingSpinner />
      </div>
      <template v-else-if="status === 'success'">
        <h2 class="justify-self-center text-2xl">Would you like to accept the request?</h2>
        <div class="mt-4 flex gap-4 justify-self-center text-lg">
          <div class="flex flex-col gap-4 font-semibold">
            <div>Email address:</div>
            <div>Customer number:</div>
          </div>

          <div class="flex flex-col gap-4">
            <div class="">{{ data?.email }}</div>
            <div class="">{{ data?.customerNumber }}</div>
          </div>
        </div>
        <div class="mt-8 flex justify-center space-x-4">
          <Button color="blue">Decline</Button>
          <Button
            color="green"
            @click="mutateAsync({ id, nonce })"
          >
            Accept
          </Button>
        </div>
      </template>
      <div v-else-if="status === 'error'">
        <h2 class="justify-self-center text-2xl">We were unable to find your access request.</h2>
      </div>
    </template>
  </Frame>
</template>
